import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import EN from '../../EN.json';
import FR from '../../FR.json';

import { useLocaleContext } from './LocaleContext';
import { localeEn } from '../misc';

const LocalizedStringsContext = createContext();

export const useLocalizedStringsContext = () =>
  useContext(LocalizedStringsContext);

const LocalizedStringsContextProvider = ({ children }) => {
  const [localizedStrings, setLocalizedStrings] = useState(EN);

  const locale = useLocaleContext();

  useEffect(() => {
    setLocalizedStrings(locale === localeEn ? EN : FR);
  }, [locale]);

  return (
    <LocalizedStringsContext.Provider value={localizedStrings}>
      {children}
    </LocalizedStringsContext.Provider>
  );
};

LocalizedStringsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default LocalizedStringsContextProvider;
